import React, { useState } from 'react';
import { Box, FormControl } from '@mui/material';
import CustomSelect from 'app/components/CustomSelect';
import CustomInput from 'app/components/CustomInput';
import CustomSwitch from 'app/components/CustomSwitch';
import FieldError from 'app/components/FieldError';
import logger from 'app/utils/logger';

interface Props {
  register?: any;
  errors?: any;
  edvBudgetData?: any;
  dataForm?: any;
  voenEdv?: any;
  beneficiarNameEdv?: any;
  handleChangeVoenEdv?: any;
  handleChangeBeneficiarNameEdv?: any;
}

const GeneralDetailsEDV = (props: Props) => {
  const {
    register,
    errors,
    edvBudgetData,
    dataForm,
    voenEdv,
    beneficiarNameEdv,
    handleChangeVoenEdv,
    handleChangeBeneficiarNameEdv,
  } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          width: '100%',

          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Benefsiar bankın kodu'}
            placeholder={'Benefsiar bankın kodu'}
            rest={{ ...register('beneficiarBankCode') }}
            disabled={true}
          />
        </FormControl>
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput title={'Benefsiar bankın adı'} rest={{ ...register('beneficiarBankName') }} disabled={true} />
        </FormControl>
      </Box>
      <FormControl
        sx={{
          width: 'fit-content',
          '@media screen and (max-width: 1100px)': {
            width: 'calc((100% - 28px) / 2)',
          },

          '@media screen and (max-width: 768px)': {
            width: '100%',
          },
        }}
      >
        <CustomInput
          title={'Benefsiar bankın hesab nömrəsi'}
          rest={{ ...register('beneficiarBankAccNumber') }}
          disabled={true}
        />
      </FormControl>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          width: '100%',

          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Benefsiarın VÖEN-İ'}
            placeholder={'Benefsiarın VÖEN-İ'}
            rest={{ ...register('beneficiarVoen'), maxLength: 10 }}
            isValid={errors.beneficiarVoen || dataForm?.error?.fields.cr_tax_no !== undefined}
            handleChange={handleChangeVoenEdv}
            value={voenEdv}
          />
          <FieldError
            error={
              errors.beneficiarVoen
                ? errors.beneficiarVoen
                : dataForm?.error?.fields.cr_tax_no && { message: dataForm?.error?.fields.cr_tax_no }
            }
          />
        </FormControl>
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Benefsiarın adı'}
            placeholder={'Benefsiarın adı'}
            rest={{ ...register('beneficiarName') }}
            isValid={errors.beneficiarName || dataForm?.error?.fields.cr_name !== undefined}
            handleChange={handleChangeBeneficiarNameEdv}
            value={beneficiarNameEdv}
          />
          <FieldError
            error={
              errors.beneficiarName
                ? errors.beneficiarName
                : dataForm?.error?.fields.cr_name && { message: dataForm?.error?.fields.cr_name }
            }
          />
        </FormControl>
      </Box>
      <FormControl
        sx={{
          width: 'fit-content',
          '@media screen and (max-width: 1100px)': {
            width: 'calc((100% - 28px) / 2)',
          },

          '@media screen and (max-width: 768px)': {
            width: '100%',
          },
        }}
      >
        <CustomInput
          title={'Benefsiarın hesab nömrəsi'}
          rest={{ ...register('beneficiarAccNumber') }}
          disabled={true}
        />
      </FormControl>
    </Box>
  );
};

export default GeneralDetailsEDV;
